import React from 'react';
export function HeroSection() {
  return <section className="relative flex items-center justify-center py-10 md:py-16 px-5 overflow-hidden bg-dark-bg" data-id="element-70">
      {/* Background Gradients */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: `
            radial-gradient(ellipse at top left, rgba(107,0,182,0.6) 0%, transparent 60%),
            radial-gradient(ellipse at bottom right, rgba(194,0,111,0.5) 0%, transparent 60%),
            radial-gradient(ellipse at center, rgba(0,102,255,0.2) 0%, transparent 70%)
          `
    }} data-id="element-71" />

      {/* Rotating Swirl */}
      <div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] rounded-full -translate-x-1/2 -translate-y-1/2 animate-swirl-rotate z-0 pointer-events-none" style={{
      background: `conic-gradient(
            from 0deg,
            rgba(255,45,155,0.08),
            rgba(107,0,182,0.08),
            rgba(0,102,255,0.08),
            rgba(255,215,0,0.06),
            rgba(255,45,155,0.08)
          )`
    }} data-id="element-72" />

      <div className="max-w-[800px] w-full flex flex-col items-center text-center relative z-10" data-id="element-73">
        <span className="inline-block bg-gradient-to-br from-magenta to-purple-mid text-white font-heading font-bold text-[0.8rem] tracking-[2px] uppercase py-1.5 px-[18px] rounded-full mb-4" data-id="element-74">
          Dr. Eduardo Ortiz · El Camino a la Recuperación
        </span>

        <h1 className="text-[clamp(2.2rem,5vw,3.8rem)] font-heading font-black leading-[1.1] mb-4" data-id="element-75">
          El problema
          <br data-id="element-76" />
          <span className="text-gradient-magenta" data-id="element-77">no eres tú.</span>
          <br data-id="element-78" />
          El problema es
          <br data-id="element-79" />
          el ciclo.
        </h1>

        <p className="text-[clamp(1rem,2vw,1.25rem)] text-white/85 leading-[1.7] mb-5 max-w-[650px]" data-id="element-80">
          Descubre el método P-C-V y reduce la ansiedad asociada a la adicción
          en un <strong data-id="element-81">40% en 21 días</strong> — con prácticas diarias que
          puedes hacer solo/a, en minutos, desde hoy.
        </p>

        {/* Book Image */}
        <div className="flex justify-center items-center relative my-6 w-full" data-id="element-82">
          <div className="absolute w-[110%] h-[110%] rounded-full bg-[radial-gradient(ellipse,rgba(194,0,111,0.2)_0%,transparent_70%)] animate-glow-pulse pointer-events-none" data-id="element-83" />
          <img src="https://cdn.magicpatterns.com/uploads/pJZQQ1y91fqaN7VirMLzzV/oDiXxM0087776.webp" alt="Placer, Culpa y Vacío — 4 volúmenes — Dr. Eduardo Ortiz" className="w-full max-w-[460px] rounded-2xl drop-shadow-[0_20px_60px_rgba(194,0,111,0.5)] drop-shadow-[0_0_40px_rgba(107,0,182,0.4)] animate-float relative z-10" data-id="element-84" />
        </div>

        <div className="bg-gradient-to-br from-[rgba(194,0,111,0.15)] to-[rgba(107,0,182,0.15)] border border-[rgba(194,0,111,0.4)] rounded-xl p-5 mb-5 w-full max-w-[650px]" data-id="element-85">
          <p className="font-heading font-bold text-[1.1rem] text-gold leading-[1.5]" data-id="element-86">
            "Llevas tiempo siendo fuerte.
            <br data-id="element-87" />
            <span className="text-magenta-bright" data-id="element-88">
              Ahora prueba ser estratégico/a.
            </span>
            "
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center flex-wrap gap-3" data-id="element-89">
          <a href="#oferta" className="inline-block bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-extrabold text-[1.05rem] py-[18px] px-[45px] rounded-full uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)] text-center w-full sm:w-auto" data-id="element-90">
            → SI, Quiero CAMBIAR MI VIDA AHORA
          </a>
          <a href="#como-funciona" className="inline-block bg-transparent text-white font-heading font-bold text-[0.9rem] py-[14px] px-[35px] rounded-full border-2 border-white/30 transition-all duration-300 hover:border-magenta-bright hover:text-magenta-bright text-center w-full sm:w-auto" data-id="element-91">
            ¿Cómo funciona?
          </a>
        </div>

        <p className="text-[0.8rem] text-white/50 mt-3" data-id="element-92">
          📦 Acceso inmediato · 4 volúmenes completos , Formato Digital · Sin
          suscripción
        </p>
      </div>
    </section>;
}